import { render, staticRenderFns } from "./admin.meldkamer.settings.page.vue?vue&type=template&id=45fcb9aa&scoped=true&"
import script from "./admin.meldkamer.settings.page.vue?vue&type=script&lang=js&"
export * from "./admin.meldkamer.settings.page.vue?vue&type=script&lang=js&"
import style0 from "./admin.meldkamer.settings.page.vue?vue&type=style&index=0&id=45fcb9aa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45fcb9aa",
  null
  
)

export default component.exports